import { Box, Typography } from "@material-ui/core";
import { SpecialDisplay } from "../../api/specialDisplays";
import { formatDate } from "../../utils/date";
import theme from "../../theme";

interface Props {
  latestSpecialDisplay?: SpecialDisplay;
}

export const TooFrequentText = ({
  latestSpecialDisplay,
}: Props): JSX.Element | null => {
  if (!latestSpecialDisplay) {
    return null;
  }

  return (
    <Box>
      <Typography
        variant="h5"
        style={{
          padding: "4px 13px",
          color: theme.palette.error.main,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        Tuote ({latestSpecialDisplay.product.id}) on ollut esillä myymälässä
        viimeisen 12kk aikana.
      </Typography>
      <Typography
        style={{
          padding: "4px 13px",
        }}
      >
        Viimeksi jaksolla "{latestSpecialDisplay.period.name} (
        {formatDate(latestSpecialDisplay.period.startDate)} -{" "}
        {formatDate(latestSpecialDisplay.period.endDate)}
        )"
      </Typography>
      {latestSpecialDisplay.specialDisplayType && (
        <Typography
          style={{
            padding: "4px 13px",
          }}
        >
          Esillepanotyypissä{" "}
          {latestSpecialDisplay.specialDisplayType.name.toLowerCase()}.
        </Typography>
      )}
    </Box>
  );
};
